import { useRoutes } from "react-router-dom";
import { BusinessApp } from "@rewardle/apps.businessapp";
import { useNavigate } from "react-router-dom";
import React, { useState } from "react";
import { authedRoutes, unAuthedRoutes, unAuthorisedlayout } from "./routes";
import { useBusinessAccessSync } from "./hooks/useBusinessAccess";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_apiKey,
  authDomain: process.env.REACT_APP_FIREBASE_authDomain,
  databaseURL: process.env.REACT_APP_FIREBASE_databaseURL,
  projectId: process.env.REACT_APP_FIREBASE_projectId,
  storageBucket: process.env.REACT_APP_FIREBASE_storageBucket,
  appId: process.env.REACT_APP_FIREBASE_appId
};

const baseUrl: any = process.env.REACT_APP_API_BASE_MENU_URL;

function App() {
  const [userDetails, setUserDetails] = useState<any>(null);
  console.log("🚀 ~ App ~ userDetails:", userDetails);
  localStorage.setItem("userDetails", JSON.stringify(userDetails || {}));

  // Global: keep billing restriction synced for the selected business
  useBusinessAccessSync();

  // 🔑 One-time cache clear if not already done
  React.useEffect(() => {
    const clearedFlag = localStorage.getItem("isClearedCache");

    if (clearedFlag !== "true") {
      // 1. Clear service worker caches
      if ("caches" in window) {
        caches.keys().then((names) => names.forEach((n) => caches.delete(n)));
      }

      // 2. Unregister service workers
      if ("serviceWorker" in navigator) {
        navigator.serviceWorker
          .getRegistrations()
          .then((regs) => regs.forEach((r) => r.unregister()));
      }

      // 3. Clear storages
      try {
        localStorage.clear();
      } catch {}
      try {
        sessionStorage.clear();
      } catch {}

      // 4. (Optional) clear known IndexedDBs
      if (window.indexedDB?.databases) {
        window.indexedDB.databases().then((dbs) => {
          dbs.forEach((db: any) => {
            if (db.name) {
              window.indexedDB.deleteDatabase(db.name);
            }
          });
        });
      }

      // 5. Mark as cleared so it runs only once
      localStorage.setItem("isClearedCache", "true");

      // 6. Reload page
      window.location.reload();
    }
  }, []);

  const renderRoutes = () => {
    let pageRoutes = [];
    const authenticatedRoutes = authedRoutes.map((route) => ({
      ...route,
      element: React.cloneElement(route.element, { userDetails })
    }));

    pageRoutes = userDetails?.token
      ? userDetails?.isAuthenticated && userDetails?.isAuthorized
        ? authenticatedRoutes
        : unAuthorisedlayout
      : unAuthedRoutes;

    return pageRoutes;
  };

  const routes = useRoutes(renderRoutes());
  const navigate = useNavigate();

  return (
    <BusinessApp
      firebaseConfig={firebaseConfig}
      apiDomain={baseUrl}
      navigate={navigate}
      setUserDetails={setUserDetails}
    >
      {routes as React.ReactNode}
    </BusinessApp>
  );
}

export default React.memo(App);
